import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Truck } from 'lucide-react';
import { listDeliverable } from '../../api/assets';
import { PageHeader } from '../../components/ui/PageHeader';
import { Card } from '../../components/ui/Card';
import { Table, Thead, Th, Tr, Td } from '../../components/ui/Table';
import { Spinner } from '../../components/ui/Spinner';
import { EmptyState } from '../../components/ui/EmptyState';
import { Button } from '../../components/ui/Button';
import { DeliverModal } from './DeliverModal';
import type { DeliverableLine } from '../../types/api';

export function DeliveryPage() {
  const [target, setTarget] = useState<DeliverableLine | null>(null);
  const deliverableQuery = useQuery({ queryKey: ['deliverable'], queryFn: listDeliverable });

  return (
    <div>
      <PageHeader title="Delivery" description="Procured order lines waiting to be delivered and registered as assets." />

      <Card>
        {deliverableQuery.isLoading ? (
          <div className="py-14 text-center">
            <Spinner />
          </div>
        ) : !deliverableQuery.data || deliverableQuery.data.length === 0 ? (
          <EmptyState icon={Truck} title="Nothing to deliver" description="Ordered lines will appear here once procured." />
        ) : (
          <Table>
            <Thead>
              <tr>
                <Th>Item</Th>
                <Th>Customer</Th>
                <Th>Site</Th>
                <Th>Qty</Th>
                <Th />
              </tr>
            </Thead>
            <tbody>
              {deliverableQuery.data.map((line) => (
                <Tr key={line.id}>
                  <Td className="font-medium text-slate-900">{line.customerCatalogItem.name}</Td>
                  <Td>{line.order.customerOrganisation.name}</Td>
                  <Td>{line.order.site.name}</Td>
                  <Td>{line.quantity}</Td>
                  <Td className="text-right">
                    <Button size="sm" onClick={() => setTarget(line)}>
                      Mark delivered
                    </Button>
                  </Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card>

      {target && <DeliverModal line={target} open={!!target} onClose={() => setTarget(null)} />}
    </div>
  );
}
